import { IThunkAction } from 'constants/types/IThunkAction';
import api from 'api';
import { startLoading, stopLoading } from 'actions';
import { errorHandler } from 'helpers/errorHandler';
import { ExamEnum } from 'constants/types/Exam';

export const getExamById = (id: number | string): IThunkAction => async (
  dispatch,
): Promise<void> => {
  try {
    startLoading()(dispatch);
    const response = await api.get(`exams/${id}`, {
      params: {
        filter: {
          include: ['session', { candidate: ['job', 'bank'] }],
        },
      },
    });
    dispatch({
      type: ExamEnum.FETCH_EXAM_SUCCESS,
      payload: response.data,
    });

  } catch (error) {
    errorHandler(error);
    dispatch({ type: ExamEnum.FETCH_EXAM_FAILURE, error });
  }
  stopLoading()(dispatch);
};
